import React, { type ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type StepListProps = {
  items: ReactNode[];
  size?: 'default' | 'compact';
};
export function StepList({
  items,
  size = 'default'
}: StepListProps) {
  const reduce = useReducedMotion();
  const textSize = size === 'compact' ? 'text-[1.45cqw]' : 'text-[1.6cqw]';
  const gap = size === 'compact' ? 'gap-[0.9cqw]' : 'gap-[1.3cqw]';
  return <ol className={`flex flex-col ${gap}`} data-id="element-26" data-mp="2ubc0nmynnfho">
      {items.map((item, index) => <motion.li key={index} className="flex items-start gap-[1.1cqw]" initial={reduce ? false : {
      opacity: 0,
      x: 12
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.35,
      delay: 0.08 + index * 0.06,
      ease: 'easeOut'
    }} data-id="element-27" data-mp="2pd0q1a0jd0ye" data-mpi={index}>
          <span className="flex h-[2.1cqw] w-[2.1cqw] shrink-0 items-center justify-center bg-mm-charcoal font-heading text-[1.1cqw] font-bold text-mm-white" aria-hidden="true" data-id="element-28" data-mp="3d3ellaibxhxq">
            {index + 1}
          </span>
          <span className={`font-body ${textSize} leading-[1.3] text-mm-charcoal`} data-id="element-29" data-mp="2wkxue10df4hx">
            {item}
          </span>
        </motion.li>)}
    </ol>;
}